import React, { useEffect, useRef } from 'react';
import {
    getAdMobBannerHeight,
    registerInFeedSlot,
} from '../../utils/admobController';
import './AdMobInFeedAd.css';

/**
 * In-feed AdMob slot for Capacitor. Reserves space matching phone AdSense rows.
 * The native adaptive banner is positioned over the most visible slot (plugin
 * only supports one overlay banner at a time).
 */
export default function AdMobInFeedAd({ slotKey }) {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;
        return registerInFeedSlot(slotKey, el);
    }, [slotKey]);

    const reserved = Math.min(120, Math.max(100, getAdMobBannerHeight()));

    return (
        <div
            ref={ref}
            className="msv-admob-infeed"
            style={{ minHeight: reserved, maxHeight: 120 }}
            aria-label="Advertisement"
        />
    );
}
